module.exports = __webpack_public_path__ + "img/source_main-con04.6ffa66f9.png";